import { commentsData } from '@/mocks/comics';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            读者热评
          </h2>
          <p className="text-sm text-foreground-500">
            来自漫画爱好者的真实阅读感受
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 border border-background-200 rounded-xl p-5 md:p-6 hover:border-primary-200 transition-colors"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className={`${comment.avatar} text-primary-600 text-lg`}></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
              </div>

              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {comment.content}
              </p>

              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-1 text-xs text-accent-600 bg-accent-50 px-2.5 py-1 rounded-full">
                  <i className="ri-book-open-line text-xs"></i>
                  {comment.comic}
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes.toLocaleString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}